<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-user-alt"></i>
        결과
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WMDS</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">결과</a>
        </li>
      </ul>
    </div>
    <!--//-------------------------------------------------------------------------Result-->
    <div class="card">
      <div class="card-body">
        <b-row class="mb-2">
          <div class="col-xl-2 col-md-12 d-flex align-self-center">
          </div>
          <div class="col-xl-2 col-md-12 d-flex align-self-center">
          </div>
          <div class="col-xl-10 col-md-12">
            <div class="form-inline">
              <label class="col-form-label mr-2" for="sel3">시작 날짜</label>
              <div class="input-group">
                <date-picker v-model="From" :lang="custom.lang.ko" :first-day-of-week="1" @change="load(true)"></date-picker>
              </div>
              <span class="mx-2">~</span>
              <label class="col-form-label mr-2" for="sel3">마지막 날짜</label>
              <div class="input-group">
                <date-picker v-model="To" :lang="custom.lang.ko" :first-day-of-week="1" @change="load(true)"></date-picker>
              </div>
            </div>
          </div>
        </b-row>
        <div class="row mb-2">
          <div class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="Allow_login">
              볼 수 있는 페이지 : {{model.length | number}} / {{so.totalRows | number}}
            </label>
            <label class="col-form-label" v-if="so.totalRows <= model.length">
              로드된 전체 결과
            </label>
          </div>
          <div class="col-xl-10 col-md-12">
            <div class="form-inline">
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="Allow_login">
              위험한 사이트만 보기
            </label>
          </div>
          <!-- checkbox 색상 변경하기 -->
          <div class="col-xl-10 col-md-12  d-flex align-self-center">
            <div class="checkbox-switch">
              <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="status" text="Danger" @change="load(true)">
              <div class="checkbox-animate">
                <span class="checkbox-off">OFF</span>
                <span class="checkbox-on">ON</span>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <!-- <div class="row mb-2" v-if="model.length">
          <div class="col-xl-4 col-md-12">
            <b-progress :value="model.length" :max="so.totalRows" variant="warning" striped :animated="true" class="mt-2"></b-progress>
          </div>
        </div> -->
        <div class="row mb-2">
          <div class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="Group_Name">
              그룹 이름
            </label>
          </div>
          <div v-if="opt.group_name" class="col-xl-3 col-md-12">
            <input type="text" class="form-control" name="Group_Name" id="Group_Name" @keydown.enter="load(true)" :disabled="false" v-model="opt.group_name">
          </div>
          <div v-if="opt.group_name" class="col-xl-1 col-md-12 mt-1">
            <b-button size="sm" id="ph_clear_group" variant="warning" @click="clearChain('group')">Clear</b-button>
          </div>
          <div v-else class="col-xl-6 col-md-12">
            <button type="button" class="btn btn-add btn-sm" data-toggle="modal" data-target="#Find_then_Group_and_Select" @click="chainGroup = true">
              그룹 선택
            </button>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="Site_FQDN">
              주소
            </label>
          </div>
          <div class="col-xl-4 col-md-12">
            <input type="text" class="form-control" name="Site_FQDN" id="Site_FQDN" @keydown.enter="load(true)" :disabled="false" v-model="opt.site_fqdn">
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-xl-12 mx-auto">
            <button type="button" class="btn btn-cancel btn-block" variant="warning" @click="clear">
              초기화
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--//-------------------------------------------------------------------------Result-->
    <div @scroll="scroll"  ref="_result_list" :style="`min-height:300px; max-height:800px;overflow-y:scroll;`">
      <b-row v-if="model.length">
        <item v-for="(item, index) in model" :key="index" :item="item" :index="index" @click="select"></item>
      </b-row>
      <b-card v-if="model.length || loading" class="w-100 text-center">
        <i v-if="loading" class="fa fa-refresh fa-spin"></i>
        <span v-else>점검 결과가 없습니다.</span>
      </b-card>
      <b-card v-else class="text-center">
        <span>해당 기간에 점검이 끝난 사이트가 없습니다. </span>
      </b-card>
      <!-- 레이아웃 조정용 -->
      <p ref="offset" v-if="$refs._result_list" :style="`margin-top:${800 - $refs._result_list.clientHeight}`"> </p>
    </div>
    <router-view @refresh="refresh()"></router-view>
    <!-- start modal -->
    <b-modal class="modal-dialog modal-dialog-centered" title="그룹 찾기 및 선택" size="xl" v-model="chainGroup" @ok="chainGroup = false" ok-variant="outline-info" ok-title="확인">
      <group-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></group-List>
    </b-modal>
    <b-modal class="modal-dialog modal-dialog-centered" title="상세 결과 정보" size="xl" v-model="detail" ok-only @ok="detail = false" ok-variant="outline-primary" ok-title="확인">
      <more :item="item"></more>
    </b-modal>

    <!-- 시작 날짜 및 마지막 날짜 유무 판별 -->
    <b-modal title="기간 설정" size="xs" v-model="date_modal" @ok="date_modal = false" ok-variant="outline-primary" ok-only ok-title="확인">
      시작 날짜 및 마지막 날짜를 지정해야 조회가 가능합니다.
    </b-modal>

    <!-- 기간 설정 범위제한 모달-->
    <b-modal title="기간 설정" size="xs" v-model="year_modal" @ok="year_modal = false" ok-variant="outline-info" ok-only ok-title="확인">
      탐지 결과 는 최대 1년단위로 조회가 가능합니다.
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>